var QuizContainer = (() => {
	var closeModal = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		modal.classList.remove('open');
		pauseVideo(container);
	}
	var openModal = (container, modalNumber) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		modal.classList.add('open');
		modal.setAttribute('data-modal-number', modalNumber);
	}
	var pauseVideo = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		modal.querySelectorAll('[js-modal-video] video').forEach(video => {
			video.pause();
		});
		const videoWrapper = modal.querySelector('[js-modal-video-wrapper]');
		if (videoWrapper) videoWrapper.classList.remove('playing');
	}
	var playVideo = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container');
		if (!bigcontainer) return;
		const modal = bigcontainer.querySelector('[js-quiz-modal]');
		if (!modal) return;
		const modalNumber = modal.getAttribute('data-modal-number');
		const video = modal.querySelector(`[js-modal-video][data-number="${modalNumber}"] video`);
		if (!video) return;
		video.play();
		const videoWrapper = modal.querySelector('[js-modal-video-wrapper]');
		if (videoWrapper) videoWrapper.classList.add('playing');
	}
	var back = (container) => {
		if (!container) {
			console.log('[quiz-container] issue');
			return;
		}
		container.setAttribute('data-value', container.getAttribute('data-value').slice(0, container.getAttribute('data-value').lastIndexOf('-')));
	}
	var initBackButtons = (container) => {
		if (!container) {
			console.log('[quiz-container] issue');
			return;
		}
		container.querySelectorAll('[js-back]').forEach(element => {
			element.addEventListener('click', () => {
				back(container);
			});
		});
	}
	var initOptions = (container) => {
		container.querySelectorAll('[js-option]').forEach(option => {
			option.addEventListener('click', () => {
				var value = option.getAttribute('data-value');
				const stateWrapper = option.closest('[js-state-wrapper]');
				if (!stateWrapper) {
					console.log('[js-state-wrapper] issue');
					return;
				}
				const checkbox = stateWrapper.querySelector('[js-checkbox]');
				if (checkbox) {
					value = value + checkbox.getAttribute('data-value');
				}
				if (container.getAttribute('data-value') != '') {
					value = container.getAttribute('data-value') + '-' + value;
				}
				container.setAttribute('data-value', value);
				localStorage.setItem('quiz-data-value', value);
			});
		});
	}
	var initCheckbox = (container) => {
		container.querySelectorAll('[js-checkbox-option]').forEach(element => {
			element.addEventListener('click', () => {
				const checkbox = element.closest('[js-checkbox]');
				if (!checkbox) {
					console.log('[js-checkbox] issue');
					return;
				}
				checkbox.setAttribute('data-value', element.getAttribute('data-value'));
			});
		});
		container.querySelectorAll('[js-checkbox-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				const checkbox = element.closest('[js-checkbox]');
				if (!checkbox) {
					console.log('[js-checkbox] issue');
					return;
				}
				if (checkbox.getAttribute('data-value') == '1') {
					checkbox.setAttribute('data-value', '2');
				} else {
					checkbox.setAttribute('data-value', '1');
				}
			});
		});
	}
	var initChooseButtons = (container) => {
		container.querySelectorAll('[js-choose-button]').forEach(element => {
			element.classList.remove('chosen');
		});
		fetch('/cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		.then(response => response.json())
		.then(cart => {
			cart.items.forEach(item => {
				container.querySelectorAll('[js-choose-button]').forEach(element => {
					let dataProductIds = element.getAttribute('data-product-ids');
					if (dataProductIds && dataProductIds != '') {
						const productIds = dataProductIds.split(',');
						productIds.forEach(productId => {
							if (String(item.product_id) == String(productId)) {
								element.classList.add('chosen');
                                const smallOptions = element.closest('.small-options');
								if (smallOptions) {
									let all_chosen = true;
									smallOptions.querySelectorAll('.small-option:has([js-choose-button]):not(:has(.optional-badge))').forEach(smallOption => {
										if (smallOption.querySelector('[js-choose-button]').classList.contains('chosen') == false) {
											all_chosen = false;
										}
									});
									if (all_chosen) {
										smallOptions.querySelectorAll('.small-option:has(.optional-badge) [js-choose-button]').forEach(button => {
											button.classList.add('chosen');
										});
									}
								}
							}
						});
					}
				});
			});
		})
		.catch(error => {
			console.error('Error fetching cart:', error);
		});
	}
	var initState = (container) => {
		let value = localStorage.getItem('quiz-data-value');

		if (value) {
			container.setAttribute('data-value', value);
		}

		initChooseButtons(container);
	}
	var initFooterDescriptionTrigger = (container) => {
		if (!container) return;
		container.querySelectorAll('[js-video-modal-trigger').forEach(element => {
			element.addEventListener('click', () => {
				openModal(container, element.getAttribute('data-target-modal'));
			});
		});
	}
	var initCloseModalButtons = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		bigcontainer.querySelectorAll('[js-close]').forEach(element => {
			element.addEventListener('click', () => {
				closeModal(container);
			});
		});
	}
	var initVideoButtons = (container) => {
		if (!container) return;
		const bigcontainer = container.closest('[js-container]');
		if (!bigcontainer) return;
		bigcontainer.querySelectorAll('[js-modal-video-play]').forEach(element => {
			element.addEventListener('click', () => {
				playVideo(container);
			});
		});
		bigcontainer.querySelectorAll('[js-modal-video-pause]').forEach(element => {
			element.addEventListener('click', () => {
				pauseVideo(container);
			});
		});
		bigcontainer.querySelectorAll('[js-modal-video] video').forEach(video => {
			video.addEventListener('ended', () => {
				playVideo(container);
				pauseVideo(container);
			});
		});
	}
	var initialize = () => {
		document.querySelectorAll('[quiz-container]').forEach(container => {
			initBackButtons(container);
			initOptions(container);
			initCheckbox(container);
			initState(container);
			initFooterDescriptionTrigger(container);
			initCloseModalButtons(container);
			initVideoButtons(container);
		});
	}
	return {
		init: initialize,
		initChooseButtons: initChooseButtons
	}
})();

var MediaGalleryVideoModalApp = (() => {
	var open = (container) => {
		if (!container) return;
		container.classList.add('open');
	}
	var close = (container) => {
		if (!container) return;
		container.classList.remove('open');
		container.querySelectorAll('video:has(+[js-modal-video-button-play])').forEach(video => {
			pause(video.closest('.modal-body'));
			video.currentTime = 0;
		});
		container.querySelectorAll('.modal-body>iframe').forEach(iframe => {
			iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
		});
	}
	var play = (videoWrapper) => {
		if (!videoWrapper) return;
		videoWrapper.classList.add('playing');
		const video = videoWrapper.querySelector('video');
		if (video) video.play();
	}
	var pause = (videoWrapper) => {
		if (!videoWrapper) return;
		videoWrapper.classList.remove('playing');
		const video = videoWrapper.querySelector('video');
		if (video) video.pause();
	}
	var initialize = () => {
		document.querySelectorAll('[js-product-video-modal] [js-close]').forEach(element => {
			element.addEventListener('click', () => {
					close(element.closest('[js-product-video-modal]'));
			});
		});
		document.querySelectorAll('media-gallery [js-product-video-modal-opener]').forEach(element => {
			element.addEventListener('click', () => {
				open(element.closest('media-gallery').querySelector('[js-product-video-modal]'));
			});
		});
		document.querySelectorAll('media-gallery [js-modal-video-button-play]').forEach(playButton => {
			playButton.addEventListener('click', () => {
				console.log('play button was clicked', playButton.closest('.modal-body'));
				play(playButton.closest('.modal-body'));
			});
		});
		document.querySelectorAll('media-gallery [js-modal-video-button-pause]').forEach(pauseButton => {
			pauseButton.addEventListener('click', () => {
				pause(pauseButton.closest('.modal-body'));
			});
		});
		document.querySelectorAll('media-gallery video:has(+[js-modal-video-button-play])').forEach(video => {
			video.addEventListener('ended', () => {
				play(video.closest('.modal-body'));
				pause(video.closest('.modal-body'));
			});
		});
	}
	return {
		init: initialize
	}
})();

var MediaGalleryApp = (() => {
	var updateSliderComponent = (container, data) => {
		const currentPage = data.detail.currentPage;
		if (currentPage == 1) {
			container.classList.add('left-end');
		} else {
			container.classList.remove('left-end');
		}
		if (currentPage == container.querySelectorAll('ul>li').length) {
			container.classList.add('right-end');
		} else {
			container.classList.remove('right-end');
		}
	}
	var updateIndicator = (indicator, sliderComponent, changedData) => {
		if (!indicator || !sliderComponent || !changedData) return;
		const currentPage = changedData.detail.currentPage;
		const totalPages = sliderComponent.querySelectorAll('ul>li').length;
		let left = 0;
		if (currentPage >= 1 && currentPage <= totalPages) {
			left = (currentPage - 1) / totalPages * 100;
		}
		indicator.style.setProperty('--left', left+'%');
	}
	var initialize = () => {
		document.querySelectorAll('media-gallery .media-gallery--indicator').forEach(element => {
			const sliderComponent = element.closest('media-gallery').querySelector('slider-component');
			if (!sliderComponent) return;
			element.style.setProperty('--width', (100.0 / sliderComponent.querySelectorAll('ul>li').length)+'%');
		});
		document.querySelectorAll('media-gallery slider-component').forEach(container => {
			container.addEventListener('slideChanged', (data) => {
				updateSliderComponent(container, data);
				updateIndicator(container.closest('media-gallery').querySelector('.media-gallery--indicator'), container, data);
			});
		});
	}
	return {
		init: initialize
	}
})();

var MhQTYText = (() => {
	let mainElement = null;
	var show = () => {
		if (!mainElement) return;
		mainElement.classList.remove('!tw-hidden');
	}
	var hide = () => {
		if (!mainElement) return;
		mainElement.classList.add('!tw-hidden');
	}
	var formatPrice = (value) => {
		value = Number(value);
		let A = parseInt(value / 100.0);
		let B = parseInt(value % 100.0);
		B = (B<10)?('0'+B):B;
		return `${A},${B}`;
	}
	var update = (value) => {
		if (!mainElement) return;
		value = Number(value);
		const sqvalue = Math.ceil(value * Number(mainElement.getAttribute('data-sqrm-multiplier')));
		const price = formatPrice(Math.ceil(sqvalue * Number(mainElement.getAttribute('data-price')))) + mainElement.getAttribute('data-currency-symbol');
		const comparePrice = formatPrice(Math.ceil(sqvalue * Number(mainElement.getAttribute('data-compare-price')))) + mainElement.getAttribute('data-currency-symbol');
		const infoElement = mainElement.querySelector('.mh-qty-text__pieces-info');
		if (!infoElement) return;
		infoElement.innerHTML = String(infoElement.getAttribute('data-template')).replace('{{ pieces }}', sqvalue);
		const comparePriceElement = mainElement.querySelector('[js-compare-price]');
		const priceElement = mainElement.querySelector('[js-price]');
		if (!comparePriceElement || !priceElement) return;
		comparePriceElement.innerHTML = comparePrice;
		priceElement.innerHTML = price;
	}
	var rerender = () => {
		if (!mainElement) return;
		const specialPricePerPiece = (document.querySelector('[js-data-special-price-per-piece]'))?document.querySelector('[js-data-special-price-per-piece]').getAttribute('data-value'):0;
		const comparePricePerPiece = (document.querySelector('[js-data-compare-price-per-piece]'))?document.querySelector('[js-data-compare-price-per-piece]').getAttribute('data-value'):0;
		const sqrmMultiplier = (document.querySelector('[js-data-sqrm-multiplier]'))?document.querySelector('[js-data-sqrm-multiplier]').getAttribute('data-value'):0;
		mainElement.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
		mainElement.setAttribute('data-other', sqrmMultiplier);
		mainElement.setAttribute('data-price', specialPricePerPiece);
		mainElement.setAttribute('data-compare-price', comparePricePerPiece);
		document.querySelectorAll('.mh-qty-text').forEach(element => {
			element.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
			element.setAttribute('data-other', sqrmMultiplier);
			element.setAttribute('data-price', specialPricePerPiece);
			element.setAttribute('data-compare-price', comparePricePerPiece);
		});
		if (document.querySelector('.quantity--square>input')) {
			update(document.querySelector('.quantity--square>input').getAttribute('data-numb-value'));
		}
	}
	var initialize = () => {
		mainElement = document.querySelector('[js-mh-qty-text]');
		document.querySelectorAll('.mh-qty-switch__label').forEach(element => {
			element.addEventListener('click', () => {
				if (element.getAttribute('data-type') == 'squarem') {
					show();
				} else {
					hide();
				}
			});
		});
		document.querySelectorAll('.quantity--square>input').forEach(element => {
			element.addEventListener('blur', () => {
				update(element.getAttribute('data-numb-value'));
				MhQTYTextFliped.update(Math.ceil(Number(element.getAttribute('data-numb-value')) * Number(mainElement.getAttribute('data-sqrm-multiplier'))))
			});
		});
	}
	return {
		init: initialize,
		update: update,
		rerender: rerender
	}
})();

var MhQTYTextFliped = (() => {
	let mainElement = null;
	var show = () => {
		if (!mainElement) return;
		mainElement.classList.remove('!tw-hidden');
	}
	var hide = () => {
		if (!mainElement) return;
		mainElement.classList.add('!tw-hidden');
	}
	var formatPrice = (value) => {
		value = Number(value);
		let A = parseInt(value / 100.0);
		let B = parseInt(value % 100.0);
		B = (B<10)?('0'+B):B;
		return `${A},${B}`;
	}
	var update = (value) => {
		value = Number(value);
		const sqvalue = parseInt(value / Number(mainElement.getAttribute('data-sqrm-multiplier')) * 100) / 100.0;
		const price = formatPrice(Math.ceil(value * Number(mainElement.getAttribute('data-price')))) + mainElement.getAttribute('data-currency-symbol');
		const comparePrice = formatPrice(Math.ceil(value * Number(mainElement.getAttribute('data-compare-price')))) + mainElement.getAttribute('data-currency-symbol');
		const infoElement = mainElement.querySelector('.mh-qty-text__pieces-info');
		if (!infoElement) return;
		infoElement.innerHTML = String(infoElement.getAttribute('data-template')).replace('{{ pieces }}', sqvalue);
		const comparePriceElement = mainElement.querySelector('[js-compare-price]');
		const priceElement = mainElement.querySelector('[js-price]');
		if (!comparePriceElement || !priceElement) return;
		comparePriceElement.innerHTML = comparePrice;
		priceElement.innerHTML = price;
	}
	var rerender = () => {
		if (!mainElement) return;
		const specialPricePerPiece = (document.querySelector('[js-data-special-price-per-piece]'))?document.querySelector('[js-data-special-price-per-piece]').getAttribute('data-value'):0;
		const comparePricePerPiece = (document.querySelector('[js-data-compare-price-per-piece]'))?document.querySelector('[js-data-compare-price-per-piece]').getAttribute('data-value'):0;
		const sqrmMultiplier = (document.querySelector('[js-data-sqrm-multiplier]'))?document.querySelector('[js-data-sqrm-multiplier]').getAttribute('data-value'):0;
		mainElement.setAttribute('data-sqrm-multiplier', sqrmMultiplier);
		mainElement.setAttribute('data-other', sqrmMultiplier);
		mainElement.setAttribute('data-price', specialPricePerPiece);
		mainElement.setAttribute('data-compare-price', comparePricePerPiece);
		if (document.querySelector('quantity-input>input[name="quantity"]')) {
			update(document.querySelector('quantity-input>input[name="quantity"]').value);
		}
	}
	var initialize = () => {
		mainElement = document.querySelector('[js-mh-qty-text-fliped]');
		if (!mainElement) return;
		document.querySelectorAll('.mh-qty-switch__label').forEach(element => {
			element.addEventListener('click', () => {
				if (element.getAttribute('data-type') == 'piece') {
					show();
				} else {
					hide();
					document.querySelectorAll('quantity-input>input[name="quantity"]').forEach(quantityElement => {
						const updatedValue = Math.ceil(Math.floor(quantityElement.value / Number(mainElement.getAttribute('data-sqrm-multiplier'))) * Number(mainElement.getAttribute('data-sqrm-multiplier')));
						quantityElement.value = updatedValue;
						update(updatedValue);
					});
				}
			});
		});
		document.querySelectorAll('quantity-input>input[name="quantity"]').forEach(element => {
			element.addEventListener('blur', () => {
				update(element.value);
				MhQTYText.update(Math.floor(element.value / Number(mainElement.getAttribute('data-sqrm-multiplier'))));
			});
		});
	}
	return {
		init: initialize,
		update: update,
		rerender: rerender
	}
})();


var MenuDrawerSearchApp = (() => {
	var searchElement = null;
	var open = () => {
		if (!searchElement) return;
		searchElement.classList.add('active');
	}
	var close = () => {
		if (!searchElement) return;
		searchElement.classList.remove('active');
	}
	var initialize = () => {
		searchElement = document.querySelector('[js-menu-drawer-search]');
		document.querySelectorAll('[js-menu-drawer-search-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				open();
			});
		});
		if (searchElement) {
			document.addEventListener('click', (e) => {
				if (!(searchElement && searchElement.contains(e.target)) && !(document.querySelector('[js-menu-drawer-search-trigger]') && document.querySelector('[js-menu-drawer-search-trigger]').contains(e.target))) {
					close();
				}
			});
		}
	}
	return {
		init: initialize
	}
})();


class MenuAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('summary+div');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

var SubcategoryModalApp = (() => {
	var open = (modal) => {
		if (!modal) return;
		modal.classList.add('open');
	}

	var close = (modal) => {
		if (!modal) return;
		modal.classList.remove('open');
	}

	var initialize = () => {
		document.querySelectorAll('[js-subcategory-modal-trigger]').forEach(element => {
			element.addEventListener('click', () => {
				const container = element.closest('[js-container]');
				if (!container) return;
				open(container.querySelector('[js-subcategory-modal]'));
			});
		});
		document.querySelectorAll('[js-subcategory-modal] [js-close]').forEach(element => {
			element.addEventListener('click', () => {
				close(element.closest('[js-subcategory-modal]'));
			});
		});
	}
	return {
		init: initialize
	}
})();

var SquareSelectorApp = (() => {
  var openModal = (container) => {
    if (!container) return;
    const modal = container.querySelector('[js-modal]');
    if (!modal) return;
    modal.classList.add('open');
		container.classList.remove('d-none');
  }
  var closeModal = (container) => {
    if (!container) return;
    const modal = container.querySelector('[js-modal]');
    if (!modal) return;
    modal.classList.remove('open');
		if (container.closest('quantity-popover') && container.closest('quantity-popover').querySelector('[data-cart-quantity]')) {
			container.closest('quantity-popover').querySelector('[data-cart-quantity]').value = parseInt(container.querySelector('[js-piece-value-wrapper] li.active').innerHTML);
			container.closest('quantity-popover').querySelector('[data-cart-quantity]').setAttribute('data-cart-quantity', parseInt(container.querySelector('[js-piece-value-wrapper] li.active').innerHTML));
			container.closest('quantity-popover').querySelector('[data-cart-quantity]').dispatchEvent(new Event('change', { bubbles: true }));
			return;
		}
    const trigger = container.querySelector('[js-trigger]');
    const selectedValue = container.querySelector('[js-selected-value]');
    if (!trigger || !selectedValue || !container.querySelector('.value-list--wrapper.active li.active')) return;
    trigger.classList.add('selected');
    selectedValue.innerHTML = `${container.querySelector('.value-list--wrapper.active li.active').innerHTML}${(container.querySelector('.square-switch .active')) ? (container.querySelector('.square-switch .active').innerHTML) : ''}`;

		if (container.hasAttribute('no-need-injection') && container.closest('product-info')) {
			container.closest('product-info').querySelectorAll('.square-selector input+label').forEach(element => {
				if (element.getAttribute('data-value') === selectedValue.innerText) {
					element.click();
				}
			});
		}

		const realQuantityElement = document.querySelector('product-info .product-page__qtty-input');
		if (container.hasAttribute('fill-quantity-input') && realQuantityElement) {
			realQuantityElement.value = parseInt(container.querySelector('.value-list--wrapper.active li.active').innerHTML);
		}
  }

  var synchronizeScrollers = (container) => {
    const pieceWrapper = container.querySelector('[js-piece-value-wrapper] .value-list');
    const squareWrapper = container.querySelector('[js-square-value-wrapper] .value-list');
    const realQuantityElement = document.querySelector('product-info .product-page__qtty-input');
    
    if (!pieceWrapper || !squareWrapper || !realQuantityElement) return;
    
    // Synchronization lock to prevent infinite loops
    let isSyncing = false;
    let syncTimeout = null;

    const syncFromPieceToSquare = () => {
      if (isSyncing) return;
      isSyncing = true;
      
      const activePiece = pieceWrapper.querySelector('li.active');
      if (activePiece || !document.querySelector('[data-sqrm-multiplier]')) {
        const sqrmMultiplier = parseFloat(document.querySelector('[data-sqrm-multiplier]').getAttribute('data-sqrm-multiplier'));
        const pieceValue = parseInt(activePiece.textContent);
        const squareValue = Math.floor(pieceValue / sqrmMultiplier);
        const squareItems = squareWrapper.querySelectorAll('li');
        squareItems.forEach(item => item.classList.remove('active'));
        
        const targetSquareItem = Array.from(squareItems).find(item => 
          parseInt(item.textContent) === squareValue
        );

        if (targetSquareItem) {
          targetSquareItem.classList.add('active');
          squareWrapper.scrollTo({
            top: targetSquareItem.offsetTop - squareWrapper.clientHeight / 2 + targetSquareItem.offsetHeight / 2,
            behavior: 'auto'
          });
        }
        realQuantityElement.value = pieceValue;
        console.log('here is the pieceValue 1', pieceValue);
      }
      
      // Release the lock after a delay
      setTimeout(() => {
        isSyncing = false;
      }, 500);
    };

    const syncFromSquareToPiece = () => {
      if (isSyncing) return;
      isSyncing = true;
      
      const activeSquare = squareWrapper.querySelector('li.active');
      if (activeSquare || !document.querySelector('[data-sqrm-multiplier]')) {
        const sqrmMultiplier = parseFloat(document.querySelector('[data-sqrm-multiplier]').getAttribute('data-sqrm-multiplier'));
        const squareValue = parseInt(activeSquare.textContent);
        const pieceValue = Math.ceil(squareValue * sqrmMultiplier);
        
        const pieceItems = pieceWrapper.querySelectorAll('li');
        pieceItems.forEach(item => item.classList.remove('active'));
        
        const targetPieceItem = Array.from(pieceItems).find(item => 
          parseInt(item.textContent) === pieceValue
        );
        
        if (targetPieceItem) {
          targetPieceItem.classList.add('active');
          pieceWrapper.scrollTo({
            top: targetPieceItem.offsetTop - pieceWrapper.clientHeight / 2 + targetPieceItem.offsetHeight / 2,
            behavior: 'auto'
          });
        }

        realQuantityElement.value = pieceValue;
        console.log('here is the pieceValue 2', pieceValue);
      }
      
      // Release the lock after a delay
      setTimeout(() => {
        isSyncing = false;
      }, 500);
    };

    pieceWrapper.addEventListener('scroll', () => {
      if (isSyncing) return; // Don't sync if we're already syncing
      
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(() => {
        syncFromPieceToSquare();
      }, 300);
    });

    squareWrapper.addEventListener('scroll', () => {
      if (isSyncing) return; // Don't sync if we're already syncing
      
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(() => {
        syncFromSquareToPiece();
      }, 300);
    });

    return { syncFromPieceToSquare, syncFromSquareToPiece };
  };

  var initEachContainer = (container) => {
    if (!container) return;
    container.addEventListener('click', (e) => {
      if (e.target.closest('li.active')) {
        closeModal(container);
      }
    });
    container.querySelectorAll('[js-trigger]').forEach(element => {
      element.addEventListener('click', () => {
        openModal(container);
      });
    });
    container.querySelectorAll('[js-modal] [js-close]').forEach(element => {
      element.addEventListener('click', () => {
        closeModal(container);
      });
    });
		document.addEventListener('click', (event) => {
			if (event.target.closest('.cart-drawer__overlay')) {
				closeModal(container);
			}
		});
    container.querySelectorAll('[js-piece-mode]').forEach(element => {
      element.addEventListener('click', () => {
        container.querySelectorAll('[js-piece-value-wrapper], [js-piece-mode]').forEach(wrapper => {
          wrapper.classList.add('active');
        });
        container.querySelectorAll('[js-square-value-wrapper], [js-square-mode]').forEach(wrapper => {
          wrapper.classList.remove('active');
        });
      });
    });
    container.querySelectorAll('[js-square-mode]').forEach(element => {
      element.addEventListener('click', () => {
        container.querySelectorAll('[js-square-value-wrapper], [js-square-mode]').forEach(wrapper => {
          wrapper.classList.add('active');
        });
        container.querySelectorAll('[js-piece-value-wrapper], [js-piece-mode]').forEach(wrapper => {
          wrapper.classList.remove('active');
        });
      });
    });

    container.querySelectorAll('.value-list').forEach((picker, index) => {
      const ul = picker.querySelector('ul');
      if (!ul) return;
      const MIN = 1, MAX = 500;
      let isDragging = false;
      let startY = 0;
      let startScrollTop = 0;

			if (!container.hasAttribute('no-need-injection')) {
				for (let i = MIN; i <= MAX; i++) {
					const li = document.createElement('li');
					li.textContent = i;
					ul.appendChild(li);
				}
			}

      function updateActive() {
        const items = ul.querySelectorAll('li');
        const centerY = picker.scrollTop + picker.clientHeight / 2;
        let closest = null, best = Infinity;
        items.forEach(li => {
          const liCenter = li.offsetTop + li.offsetHeight / 2;
          const dist = Math.abs(centerY - liCenter);
          li.classList.remove('active');
          if (dist < best) { best = dist; closest = li; }
        });
        if (closest) closest.classList.add('active');
      }

      picker.addEventListener('scroll', updateActive);

      let scrollTimeout;
      function snapToActive() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const active = ul.querySelector('li.active');
          if (active) {
            picker.scrollTo({
              top: active.offsetTop - picker.clientHeight / 2 + active.offsetHeight / 2,
              behavior: 'smooth'
            });
          }
        }, 120);
      }
      picker.addEventListener('scroll', snapToActive);

      ul.addEventListener('click', (e) => {
        if (e.target.tagName === 'LI') {
          e.preventDefault();
          e.stopPropagation();
          
          ul.querySelectorAll('li').forEach(item => item.classList.remove('active'));
          
          e.target.classList.add('active');
          
          picker.scrollTo({
            top: e.target.offsetTop - picker.clientHeight / 2 + e.target.offsetHeight / 2,
            behavior: 'smooth'
          });
					setTimeout(() => {
						closeModal(container);
					}, 400);
        }
      });

      picker.addEventListener('mousedown', (e) => {
        isDragging = true;
        startY = e.clientY;
        startScrollTop = picker.scrollTop;
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const delta = e.clientY - startY;
        picker.scrollTop = startScrollTop - delta; // reverse direction for natural feel
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          snapToActive();
        }
      });

      if (index === 0) {
        let initial = 5;
				if (container.closest('.cart-item') && container.closest('.cart-item').querySelector('[data-cart-quantity]')) {
					initial = parseInt(container.closest('.cart-item').querySelector('[data-cart-quantity]').value);
				}
        const idx = initial - MIN;
        setTimeout(() => {
          const target = ul.children[idx];
          if (target) {
						target.scrollIntoView({ block: 'center', behavior: 'auto' });
					}
        }, 100);
				if (container.closest('.cart-item')) {
					setTimeout(() => {
						container.classList.add('d-none');
					}, 500);
				}
      }
    });

    setTimeout(() => {
      synchronizeScrollers(container);
    }, 500);

    document.addEventListener('variant:change:end', () => {
      const scrollWrapper = container.querySelector('.value-list--wrapper.active .value-list');
      if (!scrollWrapper) return;
      const scrollTop = scrollWrapper.scrollTop;
      scrollWrapper.scrollTo({top: 0, behavior: 'auto'});
      scrollWrapper.scrollTo({top: scrollTop, behavior: 'auto'});
      const realQuantityElement = document.querySelector('product-info .product-page__qtty-input');
      if (!realQuantityElement) return;
			if (container.querySelector('.value-list--wrapper li.active')) {
				realQuantityElement.value = parseInt(container.querySelector('.value-list--wrapper li.active').innerText);
			}
    });
  }
  var initialize = () => {
    document.querySelectorAll('[js-square-selector]').forEach(container => {
      initEachContainer(container);
    });
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType !== Node.ELEMENT_NODE) return;
						
						if (node.hasAttribute && node.hasAttribute('js-square-selector')) {
							initEachContainer(node);
						}
						
						if (node.querySelectorAll) {
							node.querySelectorAll('[js-square-selector]').forEach(container => {
								initEachContainer(container);
							});
						}
					});
				}
			});
		});
		
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
  }
  return {
    init: initialize
  }
})();

var SaleBannerApp = (() => {
	var initEachContainer = (container) => {
		if (!container || !container.hasAttribute('data-end-date')) return;
		const end_date_time = new Date(container.getAttribute('data-end-date'));
		const interval_id = setInterval(() => {
			const current_date_time = new Date();
			if (current_date_time > end_date_time) {
				container.classList.add('d-none');
				clearInterval(interval_id);
				return;
			}
			container.classList.remove('d-none');
			if (
				current_date_time.getFullYear() === end_date_time.getFullYear() &&
				current_date_time.getMonth() === end_date_time.getMonth() &&
				current_date_time.getDay() === end_date_time.getDay()
			) {
				container.classList.add('last-date');
				return;
			}
			container.classList.remove('last-date');
		}, 1000);
	}
	var initialize = () => {
		document.querySelectorAll('[js-sale-banner]').forEach(container => {
			initEachContainer(container);
		});
	}
	return {
		init: initialize
	}
})();

var DiscountCodeCopyApplyApp = (() => {
	var copy = async (container) => {
		if (!container || !container.querySelector('[data-code]')) return;
		const code = container.querySelector('[data-code]').getAttribute('data-code');
		try {
			await navigator.clipboard.writeText(code);
			container.classList.add('copied');
			setTimeout(() => {
				container.classList.remove('copied');
			}, 2000);
		} catch (err) {
			console.error('Failed to copy text: ', err);
		}
	}
	var apply = async (container) => {
		if (!container || !container.querySelector('[data-code]')) return;
		const code = container.querySelector('[data-code]').getAttribute('data-code');
		var currentPathAndQuery = window.location.pathname + window.location.search;
    var redirectParam = encodeURIComponent(currentPathAndQuery);
    var discountUrl = '/discount/' + encodeURIComponent(code) + '?redirect=' + redirectParam;
    window.location.href = discountUrl;
	}
	var initialize = () => {
		document.querySelectorAll('[js-copiable-wrapper]').forEach(element => {
			element.addEventListener('click', () => {
				copy(element);
			});
		});
		document.querySelectorAll('[js-discount-appliable-wrapper]').forEach(element => {
			element.addEventListener('click', () => {
				apply(element);
			});
		});
	}
	return {
		init: initialize
	}
})();

var AccordionApp = (() => {
	var trigger = (container) => {
		if (!container) return;
		const trigger = container.querySelector('[js-accordion-trigger]');
		const content = container.querySelector('[js-accordion-content]');
		if (!trigger || !content) return;

		if (container.classList.contains('open')) {
			container.classList.remove('open');
			content.style.maxHeight = '0px';
		} else {
			container.classList.add('open');
			content.style.maxHeight = content.scrollHeight + 'px';
		}
	}
	var initialize = () => {
		document.addEventListener('click', (e) => {
			if (e.target.closest('[js-accordion] [js-accordion-trigger]')) {
				trigger(e.target.closest('[js-accordion]'));
			}
		});
	}
	return {
		init: initialize
	}
})();

var CartDrawerCouponCodeInputApp = (() => {
	var submit = (container) => {
		if (!container) return;
		const input = container.querySelector('[js-input]');
		if (!input) return;
		const coupon_code = input.value;
		var currentPathAndQuery = window.location.pathname + window.location.search;
    var redirectParam = encodeURIComponent(currentPathAndQuery);
    var discountUrl = '/discount/' + encodeURIComponent(coupon_code) + '?redirect=' + redirectParam;
    window.location.href = discountUrl;
	}
	var initialize = () => {
		document.addEventListener('click', (e) => {
			if (e.target.closest('[js-cart-drawer-coupon-code-input] [js-submit]')) {
				submit(e.target.closest('[js-cart-drawer-coupon-code-input]'));
			}
		});
	}
	return {
		init: initialize
	}
})();

var PDPCouponTimerApp = (() => {
  const ATTR = "js-coupon-left-time";
  const INIT_FLAG = "data-countdown-inited";

	function format(ms) {
		if (ms <= 0) return "00:00:00:00";

		const totalSeconds = Math.floor(ms / 1000);

		const days = Math.floor(totalSeconds / 86400);
		const hours = Math.floor((totalSeconds % 86400) / 3600);
		const mins = Math.floor((totalSeconds % 3600) / 60);
		const secs = totalSeconds % 60;

		const dd = String(days).padStart(2, "0");
		const hh = String(hours).padStart(2, "0");
		const mm = String(mins).padStart(2, "0");
		const ss = String(secs).padStart(2, "0");

		return `${dd}:${hh}:${mm}:${ss}`;
	}


	function startCountdown(el) {
		if (!el || el.nodeType !== 1) return;
		if (el.hasAttribute(INIT_FLAG)) return;

		const rawEnd = (el.getAttribute(ATTR) || "").trim();
		const rawNow = (el.getAttribute("js-current-time") || "").trim();
		if (!rawEnd || !rawNow) return;

		const end = new Date(rawEnd);
		const serverNow = new Date(rawNow);
		if (isNaN(end.getTime()) || isNaN(serverNow.getTime())) return;

		// difference between server-rendered now and the client clock
		const offsetMs = serverNow.getTime() - Date.now();

		el.setAttribute(INIT_FLAG, "1");

		const tick = () => {
			const nowCorrected = Date.now() + offsetMs;
			const ms = end.getTime() - nowCorrected;

			el.textContent = format(ms);

			if (ms <= 0) {
				clearInterval(timer);
				el.textContent = "00:00:00:00";
			}
		};

		tick();
		const timer = setInterval(tick, 200);
		el._countdownTimer = timer;
	}


  function initAll(root = document) {
    root.querySelectorAll(`[${ATTR}]`).forEach(startCountdown);
  }

  function observeForLaterElements() {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;

          if (node.matches?.(`[${ATTR}]`)) startCountdown(node);
          if (node.querySelectorAll) initAll(node);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  var initialize = () => {
    initAll(document);
    observeForLaterElements();
  };

  return { init: initialize };
})();

var CouponCodeRemoveApp = (() => {
	var clearAppliedCouponCodes = () => {
		fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				discount: '' // Passing an empty string removes the discount
			})
		})
		.then(response => response.json())
		.then(cart => {
			console.log('Discount removed', cart);
			window.location.reload(); 
		});
	}
	var initialize = () => {
		document.addEventListener('click', (e) => {
			if (e.target.closest('[js-coupon-code-remove]')) {
				clearAppliedCouponCodes();
			}
		})
	}
	return {
		init: initialize
	}
})();

var BDCouponDisplayApp = (() => {
	var run = (applied_discount_codes) => {
		let coupon_entry = null;
		if (applied_discount_codes) {
			Array.from(applied_discount_codes).forEach(applied_discount_code => {
				for (let i = 0; i < COUPON_ENTRY_INFO_LIST.length; i++) {
					if (applied_discount_code.code === COUPON_ENTRY_INFO_LIST[i].code_title) {
						coupon_entry = COUPON_ENTRY_INFO_LIST[i];
					}
				}
			});
		}

		let discoveredIndex = 0;

		function handleProductCard(cardElement) {
			const index = parseInt(cardElement.dataset.cardIndex);
			try {
				const LOCALE_STORAGE_KEY = 'myharry_viewed_products';
				const viewedProducts = localStorage.getItem(LOCALE_STORAGE_KEY) || '[]';
    		const viewedProductsArray = JSON.parse(viewedProducts);
				const PRODUCT_COLLECTION_ID_LIST_LOCAL_STORAGE_KEY = '[BD] Collection Id List of Products';
				const collection_id_list_object = localStorage.getItem(PRODUCT_COLLECTION_ID_LIST_LOCAL_STORAGE_KEY) || '{}';
				const collection_id_list_data_object = JSON.parse(collection_id_list_object);
				const collection_id_list = collection_id_list_data_object[viewedProductsArray[index].split('-')[0]]
				let discount_percent = 0;
				if (coupon_entry) {
					for (let i = 0; i < collection_id_list.length; i++) {
						if (collection_id_list[i] !== '') {
							Array.from(coupon_entry.collection_discount_percent_list).forEach(collection_discount_percent_entry => {
								if (String(collection_discount_percent_entry.collection_id) === String(collection_id_list[i]) && collection_discount_percent_entry.discount_percent > discount_percent) {
									discount_percent = collection_discount_percent_entry.discount_percent;
								}
							});
						}
					}
				}
				if (discount_percent == 0) {
					const priceElement = cardElement.querySelector('.card__price-discount');
					if (priceElement) priceElement.remove();
					const badgeElement = cardElement.querySelector('.card__badge-with-coupon');
					if (badgeElement) badgeElement.remove();
				} else {
					const priceElement = cardElement.querySelector('.card__price-current');
					if (priceElement) {
						priceElement.outerHTML += `
							<span class="card__price-discount">
								${String(Math.ceil(parseInt(priceElement.innerHTML.replaceAll(',', '').split(' ')[0]) * (100 - discount_percent) / 100) / 100).replace('.', ',')} ${coupon_entry.currency_symbol}
							</span>
						`;
					}
					const badgeElement = cardElement.querySelector('.card__badge');
					if (badgeElement) {
						badgeElement.outerHTML += `
							<span class="card__badge-with-coupon">-${discount_percent}%</span>
						`;
					}
				}
			} catch (error) {
				
			}
		}

		function processCard(cardElement) {
			if (!cardElement || cardElement.nodeType !== 1) return;
			if (cardElement.hasAttribute('data-productcard-processed')) return;

			// ✅ set index right away
			if (!cardElement.dataset.cardIndex) {
				cardElement.dataset.cardIndex = String(discoveredIndex++);
			}

			cardElement.setAttribute('data-productcard-processed', "1");
			handleProductCard(cardElement);
		}

		function processExisting(root = document) {
			root.querySelectorAll('.viewed-products .viewed-products__slide').forEach(processCard);
		}

		processExisting();

		const observer = new MutationObserver((mutations) => {
			for (const m of mutations) {
				for (const node of m.addedNodes) {
					if (!node || node.nodeType !== 1) continue;

					if (node.matches?.('.viewed-products .viewed-products__slide')) processCard(node);
					node.querySelectorAll?.('.viewed-products .viewed-products__slide').forEach(processCard);
				}
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });

		document.querySelectorAll('cart-drawer .total-price-with-coupon, cart-drawer .discount-code--wrapper').forEach(element => {
			if (!coupon_entry) {
				element.classList.add('d-none');
			} else {
				element.classList.remove('d-none');
			}
		});
		document.querySelectorAll('cart-drawer .discount-code--wrapper .coupon-code-list').forEach(element => {
			if (!coupon_entry) {
				element.innerHTML = ``;
			} else {
				element.innerHTML = `
					<div class="coupon-code">
						<span class="text">${coupon_entry.code_title}</span>
						<span class="icon" js-coupon-code-remove="${coupon_entry.code_title}">
							<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
								<path d="M9.90918 0.149658C9.96817 0.149701 10.0267 0.161844 10.0811 0.184814C10.1353 0.207754 10.1844 0.241455 10.2256 0.283447C10.2669 0.325605 10.3001 0.376232 10.3223 0.430908C10.3443 0.485451 10.3555 0.543948 10.3555 0.602783C10.3554 0.661731 10.3435 0.720056 10.3213 0.774658C10.3102 0.801885 10.2973 0.828309 10.2812 0.852783L10.2256 0.921143L5.93652 5.29419L10.3115 9.58228L10.3682 9.65063C10.3846 9.67476 10.3986 9.70083 10.4102 9.72778C10.4217 9.75491 10.4304 9.78305 10.4365 9.81177L10.4473 9.89868V9.89966C10.4484 9.98808 10.4232 10.0749 10.376 10.1497C10.3287 10.2244 10.2605 10.2845 10.1797 10.3206C10.0989 10.3565 10.0089 10.3674 9.92188 10.3518C9.83484 10.3362 9.7549 10.2942 9.69141 10.2327H9.69043L5.30664 5.93677L1.00781 10.3206L1.00586 10.3225C0.921915 10.4051 0.808312 10.4515 0.69043 10.4504C0.572607 10.4493 0.460353 10.4007 0.37793 10.3167C0.295633 10.2327 0.249141 10.1197 0.248047 10.0022C0.247045 9.88458 0.292111 9.77027 0.373047 9.68481L0.374023 9.68286L4.66406 5.30786L0.291016 1.02173L0.291992 1.02075C0.249181 0.980799 0.213015 0.9343 0.188477 0.881104C0.163211 0.826286 0.149679 0.766617 0.147461 0.706299C0.14525 0.646079 0.154703 0.585993 0.175781 0.529541C0.196908 0.473059 0.229131 0.421072 0.270508 0.377197C0.311912 0.33333 0.361663 0.297737 0.416992 0.273682C0.472381 0.249627 0.53238 0.237599 0.592773 0.237549C0.653181 0.237504 0.713118 0.249702 0.768555 0.273682C0.821912 0.296784 0.869608 0.330716 0.910156 0.372314H0.911133L5.29395 4.66626L9.59277 0.283447C9.63406 0.24142 9.68302 0.20773 9.7373 0.184814C9.79165 0.161907 9.8502 0.149639 9.90918 0.149658Z" fill="#DA4B3A" stroke="#DA4B3A" stroke-width="0.3"/>
							</svg>
						</span>
					</div>
				`;
			}
		});
		document.querySelectorAll('cart-drawer .totals-label__value, cart-drawer .cart-drawer--coupon-code-input--wrapper').forEach(element => {
			if (!coupon_entry) {
				element.classList.remove('d-none');
			} else {
				element.classList.add('d-none');
			}
		});
		document.querySelectorAll('.bd-coupon-bar-applied--wrapper').forEach(element => {
			if (!coupon_entry) element.classList.add('d-none');
			else {
				element.classList.remove('d-none');
				const templateText = element.querySelector('[data-template]');
				if (templateText) {
					templateText.innerHTML = String(templateText.getAttribute('data-template')).replace('((code))', coupon_entry.code_title)
				}
			}
		});
		document.querySelectorAll('.bd-coupon-bar--wrapper').forEach(element => {
			if (!coupon_entry) element.classList.remove('d-none');
			else element.classList.add('d-none');
		});
		document.querySelectorAll('.mh-qty-text').forEach(element => {
			const collection_id_list = (element.hasAttribute('data-collection-id-list')) ? element.getAttribute('data-collection-id-list').trim().split(',') : [];
			let discount_percent = 0;
			if (coupon_entry) {
				for (let i = 0; i < collection_id_list.length; i++) {
					if (collection_id_list[i] !== '') {
						Array.from(coupon_entry.collection_discount_percent_list).forEach(collection_discount_percent_entry => {
							if (String(collection_discount_percent_entry.collection_id) === String(collection_id_list[i]) && collection_discount_percent_entry.discount_percent > discount_percent) {
								discount_percent = collection_discount_percent_entry.discount_percent;
							}
						});
					}
				}
			}
			if (discount_percent > 0) {
				if (!element.hasAttribute('data-discounted')) {
					const price = parseInt(element.getAttribute('data-price'));
					element.setAttribute('data-compare-price', price);
					element.setAttribute('data-price', Math.ceil(price * (100 - discount_percent) / 100));
					element.setAttribute('data-discounted', true);
				}
				document.querySelectorAll('.quantity__input--square').forEach(input => {
					input.dispatchEvent(new Event("blur"));
				});
			}
		});
		document.querySelectorAll('product-card').forEach(productCard => {
			if (!coupon_entry) {
				productCard.querySelectorAll('.card__badge-with-coupon, .card__price-with-coupon').forEach(element => {
					element.classList.add('d-none');
				});
				productCard.querySelectorAll('.card__badge-without-coupon, .card__price-without-coupon').forEach(element => {
					element.classList.remove('d-none');
				});
			}
			const collection_id_list = (productCard.hasAttribute('data-collection-id-list')) ? productCard.getAttribute('data-collection-id-list').trim().split(',') : [];
			let discount_percent = 0;
			if (coupon_entry) {
				for (let i = 0; i < collection_id_list.length; i++) {
					if (collection_id_list[i] !== '') {
						Array.from(coupon_entry.collection_discount_percent_list).forEach(collection_discount_percent_entry => {
							if (String(collection_discount_percent_entry.collection_id) === String(collection_id_list[i]) && collection_discount_percent_entry.discount_percent > discount_percent) {
								discount_percent = collection_discount_percent_entry.discount_percent;
							}
						});
					}
				}
			}
			if (discount_percent === 0) {
				productCard.querySelectorAll('.card__badge-with-coupon, .card__price-with-coupon').forEach(element => {
					element.classList.add('d-none');
				});
				productCard.querySelectorAll('.card__badge-without-coupon, .card__price-without-coupon').forEach(element => {
					element.classList.remove('d-none');
				});
			} else {
				productCard.querySelectorAll('.card__badge-with-coupon, .card__price-with-coupon').forEach(element => {
					element.classList.remove('d-none');
				});
				productCard.querySelectorAll('.card__badge-without-coupon, .card__price-without-coupon').forEach(element => {
					element.classList.add('d-none');
				});
				productCard.querySelectorAll('.card__badge-with-coupon').forEach(element => {
					element.innerHTML = `-${discount_percent}%`;
				});
				productCard.querySelectorAll('.card__price-with-coupon .price').forEach(element => {
					element.innerHTML = `${String(Math.ceil(parseInt(element.closest('.card__price-with-coupon').getAttribute('data-price'))) / 100).replace('.', ',')} ${coupon_entry.currency_symbol}`;
				});
				productCard.querySelectorAll('.card__price-with-coupon .discounted-price').forEach(element => {
					element.innerHTML = `${String(Math.ceil(parseInt(element.closest('.card__price-with-coupon').getAttribute('data-price')) * (100 - discount_percent) / 100) / 100).replace('.', ',')} ${coupon_entry.currency_symbol}`;
				});
			}
		});
		document.querySelectorAll('.price__container-with-coupon').forEach(product_price => {
			if (!coupon_entry) {
				product_price.classList.add('d-none');
				product_price.nextElementSibling?.classList.remove('d-none');
			}
			const collection_id_list = (product_price.hasAttribute('data-collection-id-list')) ? product_price.getAttribute('data-collection-id-list').trim().split(',') : [];
			let discount_percent = 0;
			if (coupon_entry) {
				for (let i = 0; i < collection_id_list.length; i++) {
					if (collection_id_list[i] !== '') {
						Array.from(coupon_entry.collection_discount_percent_list).forEach(collection_discount_percent_entry => {
							if (String(collection_discount_percent_entry.collection_id) === String(collection_id_list[i]) && collection_discount_percent_entry.discount_percent > discount_percent) {
								discount_percent = collection_discount_percent_entry.discount_percent;
							}
						});
					}
				}
			}
			if (discount_percent === 0) {
				product_price.classList.add('d-none');
				product_price.nextElementSibling?.classList.remove('d-none');
			} else {
				product_price.classList.remove('d-none');
				product_price.nextElementSibling?.classList.add('d-none');
				product_price.querySelectorAll('.price--wrapper .value').forEach(element => {
					element.innerHTML = `${String(Math.ceil(parseInt(product_price.getAttribute('data-price'))) / 100).replace('.', ',')} ${coupon_entry.currency_symbol}`;
				});
				product_price.querySelectorAll('.discount-price--wrapper .value').forEach(element => {
					element.innerHTML = `${String(Math.ceil(parseInt(product_price.getAttribute('data-price')) * (100 - discount_percent) / 100) / 100).replace('.', ',')} ${coupon_entry.currency_symbol}`;
				});
				product_price.querySelectorAll('.discount-price--wrapper .badge').forEach(element => {
					element.innerHTML = String(element.getAttribute('data-template')).replace('((percent))', discount_percent).replace('((title))', coupon_entry.code_title);
				});
				product_price.querySelectorAll('[js-coupon-left-time]').forEach(element => {
					element.setAttribute('js-coupon-left-time', coupon_entry.end_date);
				});
				product_price.querySelectorAll('[js-current-time]').forEach(element => {
					element.setAttribute('js-current-time', coupon_entry.current_date);
				});
			}
			PDPCouponTimerApp.init();
		});
	}
	var initialize = () => {
		fetch('/cart.js')
			.then(res => res.json())
			.then(cart => {
				run(cart.discount_codes);
			});

		document.addEventListener('cart:updated', () => {
			fetch('/cart.js')
				.then(res => res.json())
				.then(cart => {
					run(cart.discount_codes);
				});
		});
		document.addEventListener('cart:line-item:updated', () => {
			fetch('/cart.js')
				.then(res => res.json())
				.then(cart => {
					run(cart.discount_codes);
				});
		});
		document.addEventListener('variant:change:end', () => {
			fetch('/cart.js')
				.then(res => res.json())
				.then(cart => {
					run(cart.discount_codes);
				});
		});
	}
	return {
		init: initialize
	}
})();

var App = (() => {
	var initialize = () => {
		QuizContainer.init();
    MediaGalleryApp.init();
		MediaGalleryVideoModalApp.init();
    MhQTYText.init();
		MhQTYTextFliped.init();
    MenuDrawerSearchApp.init();
		SaleBannerApp.init();
		DiscountCodeCopyApplyApp.init();
		AccordionApp.init();
		CartDrawerCouponCodeInputApp.init();
		CouponCodeRemoveApp.init();
		PDPCouponTimerApp.init();
		BDCouponDisplayApp.init();
		if (document.body.hasAttribute('square-calculator-ab-test')) {
			SquareSelectorApp.init();
		}
		document.querySelectorAll('.menu-drawer__navigation-container details').forEach((el) => {
			new MenuAccordion(el);
		});
    SubcategoryModalApp.init();
	}
	return {
		init: initialize
	}
})();

document.addEventListener('DOMContentLoaded', () => {
	App.init();
});

document.addEventListener('cart-item:quantity-updated', () => {
	document.querySelectorAll('[quiz-container]').forEach(container => {
		QuizContainer.initChooseButtons(container);
	});
});

document.addEventListener('cart:updated', () => {
	document.querySelectorAll('[quiz-container]').forEach(container => {
		QuizContainer.initChooseButtons(container);
	});
});

var updateVariantDiscount = async () => {
	const response = await fetch(window.location.href);
	const html = await response.text();
	const parser = new DOMParser();
	const newDoc = parser.parseFromString(html, 'text/html');
	
	const currentHeading = document.querySelector('product-timer .heading');
	const newHeading = newDoc.querySelector('product-timer .heading');
	if (currentHeading && newHeading) {
		currentHeading.innerHTML = newHeading.innerHTML;
	}

	const currentPrice = document.querySelector('product-timer .discounted-price .price');
	const newPrice = newDoc.querySelector('product-timer .discounted-price .price');
	if (currentPrice && newPrice) {
		currentPrice.innerHTML = newPrice.innerHTML;
	}
}

document.addEventListener('variant:change:end', () => {
	MhQTYText.rerender();
	MhQTYTextFliped.rerender();
	updateVariantDiscount();
});